import React, { useEffect, useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "../api/axiosInstance";
import DashboardLayout from "./DashboardLayout";
import {
  getUnsettledInvoiceData,
  requestPayment,
} from "../services/FinancialService";
import { CustomerContext } from "../context/customerContext";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { FaRegCreditCard } from "react-icons/fa";

const UnSettledInvoiceList = () => {
  const { customer, setCustomer } = useContext(CustomerContext);
  const [unsettledInvoices, setUnsettledInvoices] = useState(null);
  const [payingInvoiceId, setPayingInvoiceId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const navigate = useNavigate();

  //  فقط مشتری تست
  const isPaymentTestEnabled =
    (customer?.accountGroupID === 2047 ||
      customer?.accountGroupID === 2050 ||
      customer?.accountGroupID === 2042);

  const handleOnlinePayment = async (unsettledInvoice) => {
    localStorage.setItem("paymentReturnTo", "/unSettledInvoiceList");
    const invoiceId = parseInt(unsettledInvoice.invoiceID, 10);

    if (!invoiceId) {
      alert("شناسه فاکتور نامعتبر است");
      return;
    }

    if (payingInvoiceId === invoiceId) return;
    setPayingInvoiceId(invoiceId);

    try {
      const payload = {
        InvoiceId: invoiceId,
        Amount: Math.round(Number(unsettledInvoice.remainAmount)),
        Name: customer?.customerName || "",
        Description: `پرداخت شماره فاکتور ${unsettledInvoice.number}`,

      };

      const response = await requestPayment(payload);
      const paymentUrl = response.data?.paymentUrl;

      if (!paymentUrl) throw new Error("paymentUrl دریافت نشد");

      // window.location.href = paymentUrl;
      window.open(paymentUrl, "_self");

    } catch (error) {
      console.error("خطا در اتصال به درگاه:", error);
      alert("خطا در اتصال به درگاه پرداخت");
      setPayingInvoiceId(null);
    }
  };

  useEffect(() => {
    if (!customer?.customerId) return;
    const fetchUnsettledInvoiceData = async () => {
      try {
        const response = await getUnsettledInvoiceData(customer.customerId);
        setUnsettledInvoices(response.data);
      } catch (error) {
        console.error("خطا در دریافت اطلاعات فاکتورهای تسویه نشده:", error);
      }
    };

    fetchUnsettledInvoiceData();
  }, [customer]);

  if (!unsettledInvoices) {
    return (
      <DashboardLayout>
        <div className="text-center text-blue-800">
          در حال بارگذاری اطلاعات ...
        </div>
      </DashboardLayout>
    );
  }

  // صفحه‌بندی:
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentInvoices = unsettledInvoices.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(unsettledInvoices.length / itemsPerPage);

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between  mb-4">
        <h1 className="text-base sm:text-lg md:text-xl font-bold text-blue-700">
          لیست فاکتورهای تسویه نشده
        </h1>
        <button
          onClick={() => navigate("/financial-info")}
          className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
        >
          بازگشت
        </button>
      </div>
      <div className="w-full overflow-x-auto rounded-xl">
        <table className="w-full min-w-[600px] text-sm text-right bg-white shadow rounded-xl overflow-hidden">
          <thead className="bg-blue-100 text-blue-900">
            <tr>
              <th className="px-2 py-1 sm:p-3">ردیف</th>
              <th className="px-2 py-1 sm:p-3">شماره فاکتور</th>
              <th className="px-2 py-1 sm:p-3">تاریخ </th>
              <th className="px-2 py-1 sm:p-3">مبلغ (ریال)</th>
              <th className="px-2 py-1 sm:p-3">وضعیت تسویه</th>
              <th className="px-2 py-1 sm:p-3">مانده تسویه نشده(ریال)</th>
              <th className="px-2 py-1 sm:p-3">روز عدم تسویه</th>
              <th className="px-2 py-1 sm:p-3"></th>
            </tr>
          </thead>
          <tbody>
            {currentInvoices.map((unsettledInvoice, index) => (
              <tr
                key={unsettledInvoice.id}
                // className="border-t hover:bg-blue-50"
                className={`
                  border-t
                  transition-colors
                  ${unsettledInvoice.state === 44
                    ? "bg-yellow-50 hover:bg-yellow-100"
                    : "hover:bg-blue-50"
                  }
                `}
              >
                <td className="px-2 py-1 sm:p-3">{indexOfFirst + index + 1}</td>{" "}
                {/* {index + 1} */}
                {/* شماره ردیف */}
                <td className="px-2 py-1 sm:p-3">{unsettledInvoice.number}</td>
                <td className="px-2 py-1 sm:p-3">
                  {" "}
                  {new DateObject({
                    date: unsettledInvoice.date,
                    calendar: "gregorian", // مشخص کردن ورودی میلادی
                  })
                    .convert(persian) // تبدیل به تقویم شمسی
                    .format("YYYY/MM/DD")}
                </td>
                {/* <td className="p-3">{inv.date.split("T")[0]}</td> */}
                <td className="px-2 py-1 sm:p-3">
                  {unsettledInvoice.netPrice.toLocaleString()}
                </td>
                <td className="px-2 py-1 sm:p-3">
                  {/* {unsettledInvoice.stateString} */}
                  {/* <span
                    className={`font-medium ${
                      unsettledInvoice.state === 44
                        ? "text-yellow-700"
                        : "text-gray-700"
                    }`}
                  >
                    {unsettledInvoice.stateString}
                  </span> */}
                  <span
                    className={`font-medium ${unsettledInvoice.state === 44 ||
                      unsettledInvoice.isPaymentLocked ||
                      payingInvoiceId === unsettledInvoice.invoiceID
                      ? "text-yellow-700"
                      : "text-gray-700"
                      }`}
                  >
                    {unsettledInvoice.state === 44 ||
                      unsettledInvoice.isPaymentLocked ||
                      payingInvoiceId === unsettledInvoice.invoiceID
                      ? "در حال تسویه"
                      : unsettledInvoice.stateString}
                  </span>
                </td>
                <td className="px-2 py-1 sm:p-3">
                  {unsettledInvoice.remainAmount.toLocaleString()}
                </td>
                <td className="px-2 py-1 sm:p-3">
                  {unsettledInvoice.remainSettlementDays}
                </td>
                <td className="px-2 py-1 sm:p-3 text-center">
                  {/* <button
                    onClick={() => handleOnlinePayment(unsettledInvoice)}
                    className="bg-blue-600 hover:bg-blue-700 text-white text-[11px] sm:text-xs font-medium py-1 px-2.5 rounded-md shadow-sm transition-all duration-200 hover:scale-105"
                  >
                    پرداخت
                  </button> */}
                  {/* ✅ پرداخت فقط برای مشتری تست */}
                  {isPaymentTestEnabled &&
                    unsettledInvoice.remainAmount > 0 && (
                      <button
                        disabled={
                          payingInvoiceId === unsettledInvoice.invoiceID ||
                          unsettledInvoice.state === 44 ||
                          unsettledInvoice.isPaymentLocked
                        }
                        onClick={() => handleOnlinePayment(unsettledInvoice)}
                        className={`text-white text-[11px] sm:text-xs font-medium py-1 px-2.5 rounded-md shadow-sm transition-all
        ${unsettledInvoice.isPaymentLocked || unsettledInvoice.state === 44
                            ? "bg-yellow-400 cursor-not-allowed"
                            : payingInvoiceId === unsettledInvoice.invoiceID
                              ? "bg-gray-400 cursor-not-allowed"
                              : "bg-blue-600 hover:bg-blue-700 hover:scale-105"
                          }`}
                      >
                        {unsettledInvoice.isPaymentLocked || unsettledInvoice.state === 44
                          ? "در حال تسویه "
                          : payingInvoiceId === unsettledInvoice.invoiceID
                            ? "در حال اتصال..."
                            : "پرداخت"}
                      </button>
                    )}
                </td>
              </tr>
            ))}

            {/* {isPaymentTestEnabled &&
                    unsettledInvoice.remainAmount > 0 && (
                      <button
                        disabled={
                          payingInvoiceId === unsettledInvoice.invoiceID
                        }
                        onClick={() => handleOnlinePayment(unsettledInvoice)}
                        className={`text-white text-[11px] sm:text-xs font-medium py-1 px-2.5 rounded-md shadow-sm transition-all
                        ${
                          payingInvoiceId === unsettledInvoice.invoiceID
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700 hover:scale-105"
                        }`}
                      >
                        {payingInvoiceId === unsettledInvoice.invoiceID
                          ? "در حال اتصال..."
                          : "پرداخت"}
                      </button>
                    )}
                </td>
              </tr>
            ))} */}
            {unsettledInvoices.length === 0 && (
              <tr>
                <td colSpan="4" className="p-4 text-center text-gray-500">
                  فاکتور موجود نیست.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* صفحه‌بندی */}
      {totalPages > 1 && (
        <div className="flex justify-center gap-2 mt-4 flex-wrap">
          {/* دکمه قبلی */}
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            className={`px-3 py-1 rounded ${currentPage === 1 ? "bg-gray-300 text-gray-600" : "bg-blue-100"
              }`}
          >
            قبلی
          </button>

          {/* صفحه‌ها - فقط ۵ عدد نمایش داده شود */}
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((page) => {
              if (totalPages <= 5) return true;
              if (currentPage <= 3) return page <= 5;
              if (currentPage >= totalPages - 2) return page >= totalPages - 4;
              return Math.abs(currentPage - page) <= 2;
            })
            .map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`px-3 py-1 rounded ${currentPage === page
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700"
                  }`}
              >
                {page}
              </button>
            ))}

          {/* دکمه بعدی */}
          <button
            disabled={currentPage === totalPages}
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            className={`px-3 py-1 rounded ${currentPage === totalPages
              ? "bg-gray-300 text-gray-600"
              : "bg-blue-100"
              }`}
          >
            بعدی
          </button>
        </div>
      )}
    </DashboardLayout>
  );
};

export default UnSettledInvoiceList;
